jQuery.feature_import("js-notification-drawer",
    () => require("./notifications-app"),
    mod => mod.feature_js_notifications_drawer
); 